import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Privacy from './pages/Privacy';
import Download from './pages/Download';

function App() {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {/* Legal pages — always public, no login needed */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/download" element={<Download />} />

        {/* Main app — login or dashboard */}
        <Route path="*" element={user ? <Dashboard /> : <Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
